export class InsuranceDetail {
    /*insurance_company_id: string;
    insurance_plan_id: string;*/
    insurance_id: string;
    insurance_number: string;
    primary_account_holder: number;
}
